$(() => {
  const header = $('.oxy-header-wrapper');
  const menuWrap = header.find('.mega-menu-wrap');
  const buttons = menuWrap.find('[class*="ct-link-button"]');
  const smiley = $('.kustomer-avatar');
  const hH = header.outerHeight(true);
  let lastScrollTop = 0;
  // clone for mobile
  buttons.each((id, btn) => {
    const classes = $(btn).attr('class').split(' ');
    const regex = /^ct-link-button--[a-z-]+$/;
    const btnClass = classes.find(element => regex.test(element));
    menuWrap.append($(btn).find('> a').clone().addClass(`ct-link-button ${btnClass}`));
  });
  menuWrap.find('> .ct-link-button').wrapAll('<div class="menu-btns-wrapper"></div>');
  const toggleScrolledClass = () => {
    const currentScrollTop = $(window).scrollTop();
    if (currentScrollTop > 0) {
      if (currentScrollTop > lastScrollTop) {
        $('body').addClass('scrolled main-menu-hide');
      } else {
        $('body').removeClass('scrolled main-menu-hide');
      }
    } else {
      $('body').removeClass('scrolled main-menu-hide');
    }
    lastScrollTop = currentScrollTop;
  };
  smiley.on('click', () => {
    $('body').removeClass('main-menu-hide');
  });
  $(window).on('mousemove', (e) => {
    const y = e.clientY;
    if(hH >= y) {
      $('body').removeClass('main-menu-hide');
    }
  });
  $(window).on('load scroll', () => {
    toggleScrolledClass();
  });
});
